import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const GradientFullCircle = ({ height = 12, width = 12, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 12 12" {...props}>
    <circle
      cx="6"
      cy="6"
      r="5"
      transform="rotate(-180 6 6)"
      stroke="url(#paint0_linear_844_130385)"
      strokeWidth="1.25"
    />
    <defs>
      <linearGradient
        id="paint0_linear_844_130385"
        x1="9.90643"
        y1="1"
        x2="2.09357"
        y2="11"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF4D80" />
        <stop offset="0.0667" stopColor="#FE4D81" />
        <stop offset="0.1333" stopColor="#FC4E82" />
        <stop offset="0.2" stopColor="#F95086" />
        <stop offset="0.2667" stopColor="#F4528A" />
        <stop offset="0.3333" stopColor="#EE5490" />
        <stop offset="0.4" stopColor="#E65897" />
        <stop offset="0.4667" stopColor="#DE5B9F" />
        <stop offset="0.5333" stopColor="#D65FA7" />
        <stop offset="0.6" stopColor="#CE62AF" />
        <stop offset="0.6667" stopColor="#C666B6" />
        <stop offset="0.7333" stopColor="#C068BC" />
        <stop offset="0.8" stopColor="#BB6AC0" />
        <stop offset="0.8667" stopColor="#B86CC4" />
        <stop offset="0.9333" stopColor="#B66DC5" />
        <stop offset="1" stopColor="#B56DC6" />
      </linearGradient>
    </defs>
  </SvgIcon>
);
